module.exports = __webpack_public_path__ + "img/hero-contact.09788d93.jpg";